<template>
  <v-app-bar dense :color="color" fixed dark id="mainHeader" elevation="0" style='z-index: 999'>
    <v-spacer></v-spacer>
    <div
      style="
        position: absolute;
        right: 0;
        left: 0;
        margin: auto;
        width: 100%;
        max-width: 383px;
      "
    >
      <slot name="center"></slot>
    </div>
    <v-spacer></v-spacer>
    <template>
      <slot name="right"></slot>
    </template>
  </v-app-bar>
</template>

<script>
import SmallIconButton from '/src/components/uiParts/buttons/SmallIconButton'
import AccountMenuContainer from '/src/container/shared/Header/AccountMenuContainer'
import ProfileListItem from '/src/components/uiParts/ListItems/Profile'
import PasswordListItem from '/src/components/uiParts/ListItems/Password'
import HeaderSearchFieldContainer from '/src/container/shared/Header/HeaderSearchFieldContainer'

export default {
  name: 'HeaderLayout',
  components: {
    HeaderSearchFieldContainer,
    PasswordListItem,
    ProfileListItem,
    AccountMenuContainer,
    SmallIconButton
  },
  props: {
    color: {
      type: String,
      default: '#0013C0'
    }
  }
}
</script>

<style></style>
